/* @flow */
import { ActionTypes } from 'constants/RoleVerificationConstants';
import Store from 'lib/Store';

export type RoleVerification = {
  is_school: boolean,
  role: string, // TODO what's the domain of thise value?
  organization_id: number,
};

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class RoleVerificationStore extends Store {
  getInitialState() {
    return {
      roleVerification: null,
    };
  }

  getRoleVerification(): ?RoleVerification {
    return this.state.roleVerification;
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.ROLE_VERIFICATION_LOADED:
        this.setState({ roleVerification: action.roleVerification });
        this.emitChange();
        break;
      default:
        break;
    }
  }
}

export default new RoleVerificationStore();
